<template>
    <el-dialog
    title="课程"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="90%"
      :append-to-body="true"
  >
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="课程名称">
          <el-input placeholder="请输入课程名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>

        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button type="primary" icon="el-icon" @click="reast">重置</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加课程</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="课程名称"></el-table-column>


            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add"  :ocourse_id="ocourse_id" :ocourse_catalogue_id="ocourse_catalogue_id" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ocourse_url_id="ocourse_url_id" :ocourse_id="ocourse_id"  :ocourse_catalogue_id="ocourse_catalogue_id" v-if="open_edit"   @close="closeEdit"></Edit>

  </div>
</el-dialog>
</template>

<script>
  import OcourseApi from '@/api/ocourse.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,

    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          ocourse_category_code:""
        },

        open_add:false,
        open_edit:false,
        dialogVisible:false,
        ocourse_category:[],
        open_tz:false,
        obj:{},
        code:"",
        open_c:false,
        ocourse_url_id:0,
      };
    },
    created() {
      this.dialogVisible = this.open
      /*获取列表*/
      this.getTableList();
   
    },
    props: ["ocourse_catalogue_id",'open','ocourse_id'],
    methods: {
      /*关闭弹窗*/
      dialogFormVisible(result) {
        this.$emit("close", { openDialog: false,"type":"" });
      },
      cancelFunc(){//取消
        this.dialogFormVisible("error")
      },

      reast(){
        this. formInline= {
          search:"",
          ocourse_category_code:""
        }
        this.getTableList();
      },
   
   
      setting(e){//课程标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.ocourse_catalogue_id = self.ocourse_catalogue_id
        self.loading = true;
        OcourseApi.listUrl(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.ocourse_url_id = row.ocourse_url_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            OcourseApi.delUrl(
              {
                ocourse_url_id: row.ocourse_url_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ocourse/index/catalogue/url/index.vue